export const enum GLOBAL_DATA {
  /**
   * 下拉选择加载器
   */
  LOADERS = 'LOADERS',
  /**
   * 下拉选择加载器
   */
  SELECT_REQUEST = 'SELECT_REQUEST',
  /**
   * 表格数据请求
   */
  TABLE_REQUEST = 'TABLE_REQUEST',
  /**
   * 表单自动保存
   */
  FORM_REQUEST_SAVE = 'FORM_REQUEST_SAVE',
  /**
   * 表单请求数据
   */
  FORM_REQUEST_LOAD = 'FORM_REQUEST_LOAD',
  /**
   * 搜索树请求
   */
  TREE_REQUEST = 'TREE_REQUEST',
  /**
   * 文件下载
   */
  FILE_DOWNLOAD = 'FILE_DOWNLOAD'
}